import { useSelector } from "react-redux";
import { PurchaseOrderState } from "./purchaseOrder.slice";

export const usePurchaseOrderDetails = () => {
  return useSelector(({ purchaseOrder }: PurchaseOrderState) => purchaseOrder);
};
